import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/content';
export function TestimonialsSection() {
  return <section className="grid-bg w-full bg-night px-5 py-20" aria-labelledby="testimonios-titulo" data-id="element-180" data-mp="20qxbb6fr8cr4">
      <div className="mx-auto max-w-5xl" data-id="element-181" data-mp="1mzisp0predkl">
        <h2 id="testimonios-titulo" className="text-center font-display text-2xl font-bold leading-snug text-cream md:text-4xl" data-id="element-182" data-mp="1r1dus7fikuzf">
          Lo que dicen nuestros lectores
        </h2>
        <p className="mt-4 text-center text-sm text-cream-dim md:text-base" data-id="element-183" data-mp="1i1h2zwxtvg05">Más de 4.000 lectores satisfechos</p>

        <ul className="mt-12 grid gap-5 md:grid-cols-3" data-id="element-184" data-mp="1427xbr7904af">
          {testimonials.map(testimonial => <li key={testimonial.name} className="flex h-full flex-col rounded-xl border border-night-line bg-night-card p-6" data-id="element-185" data-mp="183t7v5wb86hg">
              <div className="flex gap-1 text-gold" aria-label="5 de 5 estrellas" data-id="element-186" data-mp="32gj2xqyezlqf">
                {Array.from({
              length: 5
            }).map((_, index) => <StarIcon key={index} className="h-4 w-4 fill-gold" aria-hidden="true" data-id="element-187" data-mp="2uzztcnhxg6sm" data-mpi={index} />)}
              </div>
              <blockquote className="mt-4 text-base italic leading-relaxed text-cream" data-id="element-188" data-mp="2q0n8276pf7s5">
                «{testimonial.quote}»
              </blockquote>
              <div className="mt-auto flex items-center gap-3 pt-6" data-id="element-189" data-mp="2ztm0k05bnih1">
                <span aria-hidden="true" className="flex h-10 w-10 items-center justify-center rounded-full border border-gold/50 bg-night-soft font-display text-sm font-bold text-gold" data-id="element-190" data-mp="2c26rzpmyc4xc">
                  {testimonial.name.charAt(0)}
                </span>
                <span className="text-sm text-cream-dim" data-id="element-191" data-mp="2h1jpr5fd2wep">
                  <strong className="block font-semibold text-cream" data-id="element-192" data-mp="2h45wj2ufh7vv">{testimonial.name}</strong>
                  {testimonial.location}
                </span>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}